import { chatAgentBackgroundColor, chatAgentFontColor, userMessageDropShadow } from 'globals/colors';
import { iconArticle } from '../../../../../globals/assets';

const styles = {
  message: {
    fontSize: '12px',
    fontWeight: '400',
    padding: '7px 12px',
    borderRadius: '9px 9px 9px 0',
    display: 'inline-block',
    maxWidth: '250px',
    margin: '5px 5px',
    lineHeight: '16px',
    color: chatAgentFontColor,
    backgroundColor: chatAgentBackgroundColor,
    wordWrap: 'break-word',
    boxShadow: `0 0 7px 0 ${userMessageDropShadow}`,
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  wrapper: {
    display: 'flex',
    cursor: 'default',
  },
  userAvatar: {
    margin: '0px 5px',
  },
  title: {
    fontWeight: '500',
    maxHeight: '215px',
  },
  articleItem: {
    display: 'flex',
    cursor: 'pointer',
    ':hover': {
      icon: {
        opacity: '1',
        transition: 'all 150ms',
      },
    },
  },
  icon: {
    backgroundImage: `url("${iconArticle}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '16px',
    height: '18px',
    width: '18px',
    opacity: '.4',
    transition: 'all 150ms',
    marginRight: '5px',
  },
};

export default styles;
